import React from "react";
import { Col, FormControl, FormGroup, FormLabel, Row } from "react-bootstrap";
import { InputBox } from "../../components";
import { PendingCommand, QuestionInterface } from "../../helpers";


interface Props {
  question: QuestionInterface
  rootQuestions: QuestionInterface[]
  sendCommand: (cmd: PendingCommand) => void
}


export const QuestionEdit: React.FC<Props> = props => {

  const [question, setQuestion] = React.useState<QuestionInterface>(null);


  const handleChange = (e: any) => {
    let q: QuestionInterface = { ...question };
    let val = e.currentTarget.value;
    switch (e.currentTarget.id) {
      case "parentId": q.parentId = parseInt(val, 0); break;
      case "fieldType": q.fieldType = val; break;
      case "keyName": q.keyName = val; break;
      case "title": q.title = val; break;
      case "description": q.description = val; break;
      case "placeholder": q.placeholder = val; break;
      case "regex": q.regex = val; break;
      case "choices": q.choices = val; break;
    }
    setQuestion(q);
  }

  const handleCancel = () => {
    props.sendCommand({ action: "cancelEditQuestion", parameter: "" })
  }

  const handleSave = () => {
    props.sendCommand({ action: "updateQuestion", parameter: question })
  }

  const getDeleteFunction = () => (question?.id > 0) ? handleDelete : undefined

  const handleDelete = () => {
    if (window.confirm("Are you sure you wish to permanently delete this question?")) {
      props.sendCommand({ action: "deleteQuestion", parameter: question })
    }
  }


  const init = () => { if (props.question) setQuestion(props.question); }

  React.useEffect(init, [props.question]);

  const getRootQuestions = () => {
    const result: React.ReactElement[] = [];
    props.rootQuestions.forEach(rq => {
      if (rq.id !== question?.id) result.push(<option value={rq.id} >{rq.title}</option>)
    })
    return result;
  }

  return (
    <>
      <InputBox headerIcon="fas fa-question" headerText="Edit Question" saveText="Update" cancelFunction={handleCancel} saveFunction={handleSave} deleteFunction={getDeleteFunction()} deleteText="Delete question" >
        <Row>
          <Col>
            <FormGroup className="mb-3">
              <FormLabel>Parent Question</FormLabel>
              <FormControl as="select" id="parentId" value={question?.parentId} onChange={handleChange} >
                <option value="0">None</option>
                {getRootQuestions()}
              </FormControl>
            </FormGroup>
          </Col>
          <Col>
            <FormGroup className="mb-3">
              <FormLabel>Answer Type</FormLabel>
              <FormControl as="select" id="fieldType" value={question?.fieldType} onChange={handleChange} >
                <option value="header">Heading</option>
                <option value="label">Label</option>
                <option value="array">Array</option>
                <option value="string">Single Value</option>
                <option value="text">Text Area</option>
                <option value="list">Drop Down List</option>
                <option value="bool">Checkbox</option>
                <option value="string[]">List of Values</option>
                <option value="image">Image</option>
                <option value="image[]">Images</option>
                <option value="video">Video</option>
                <option value="silentVideo">Silent Video</option>
                <option value="file">File</option>
                <option value="file[]">Files</option>
                <option value="designer">Designer</option>
                <option value="canva">Canva</option>
                <option value="hidden">Hidden</option>
                <option value="moderatedList">Moderated List</option>
                <option value="playlist">Playlist</option>
                <option value="playlistOrMessage">Playlist or Message</option>
                <option value="message">Message</option>
              </FormControl>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup className="mb-3">
              <FormLabel>Key Name</FormLabel>
              <FormControl id="keyName" value={question?.keyName} onChange={handleChange} />
            </FormGroup>
          </Col>
          <Col>
            <FormGroup className="mb-3">
              <FormLabel>Title</FormLabel>
              <FormControl id="title" value={question?.title} onChange={handleChange} />
            </FormGroup>
          </Col>
        </Row>
        <FormGroup className="mb-3">
          <FormLabel>Description</FormLabel>
          <FormControl id="description" value={question?.description} onChange={handleChange} />
        </FormGroup>
        <Row>
          <Col>
            <FormGroup className="mb-3">
              <FormLabel>Placeholder Value</FormLabel>
              <FormControl id="placeholder" value={question?.placeholder} onChange={handleChange} />
            </FormGroup>
          </Col>
          <Col>
            <FormGroup className="mb-3">
              <FormLabel>Regex</FormLabel>
              <FormControl id="regex" value={question?.regex} onChange={handleChange} />
            </FormGroup>
          </Col>
        </Row>
        <FormGroup className="mb-3">
          <FormLabel>Choices</FormLabel>
          <FormControl id="choices" value={question?.choices} onChange={handleChange} />
        </FormGroup>
      </InputBox>
    </>
  );
};